<div class="container">
  <div>
    <mat-dialog-content>
      <p
        class="text"
        [innerHtml]="
          preferredLanguage?.countryCode === 'US'
            ? ('foodLawComponent.americanFoodLawText' | translate)
            : ('foodLawComponent.europeanFoodLawText' | translate)
        "
      ></p>
    </mat-dialog-content>
  </div>
  <div fxHide.lt-md="true">
    <button class="close-button" mat-button (click)="onCloseClicked()">
      {{ "foodLawComponent.close" | translate }}
    </button>
  </div>
  <div fxHide.gt-sm="true">
    <img
      class="close-image"
      alt="close-image"
      src="assets/icons/close.png"
      mat-button
      (click)="onCloseClicked()"
    />
  </div>
</div>
